import React from "react";

import cx from "classnames";
import {OptionProps, SingleValueProps, components} from "react-select";

import {MenuSortOption} from "@components/Menu/interfaces";
import CustomSelect from "@components/forms/inputs/CustomSelect";
import {CustomSelectProps} from "@components/forms/inputs/CustomSelect/CustomSelect";

import defaultStyles from "../CustomSelect/CustomSelect.scss";
import styles from "./SortingSelect.scss";

interface SortingSelectProps extends Omit<CustomSelectProps, "options"> {
  sortOptions?: MenuSortOption[];
}

type SortingSelectOption = {
  label: string;
  value: string;
  icon: string;
};

const CustomSingleValue = (
  props: SingleValueProps<SortingSelectOption, false, any>
) => (
  <components.SingleValue {...props} className={styles.customSingleValue}>
    <img className={styles.sortingSelectedIcon} src={props.data.icon} alt="" />
    {props.data.label}
  </components.SingleValue>
);

const CustomOption = (props: OptionProps<SortingSelectOption>) => {
  return (
    <div
      {...props.innerProps}
      className={cx(
        props.className,
        defaultStyles.defaultOption,
        styles.option,
        {
          [defaultStyles.selected]: props.isSelected,
          [defaultStyles.disabled]: props.isDisabled,
          [defaultStyles.focused]: props.isFocused,
        }
      )}
    >
      <img src={props.data.icon} alt="" />
      <span>{props.label}</span>
    </div>
  );
};

export default function SortingSelect({
  name,
  label,
  value,
  sortOptions,
  onChange,
  ...rest
}: SortingSelectProps): JSX.Element {
  const options = sortOptions?.map((option, index) => ({
    label: option.name,
    value: index,
    icon: option.icon,
  }));

  return (
    <>
      {options?.length && (
        <CustomSelect
          label={label}
          name={name}
          options={options}
          customOption={CustomOption}
          customSingleValue={CustomSingleValue}
          className={rest.className}
          value={value}
          onChange={onChange}
          {...rest}
        />
      )}
    </>
  );
}
